'use strict';

var React = require('react'),
    Icon = require('../atoms/Icon'),
    pluralize = require('../utils/pluralize'),
    formatTime = require('../utils/formatTime'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    createFlexibleImageQueueMixin = require('../mixins/createFlexibleImageQueueMixin'),
    { PropTypes } = React;

require('./legacy/EditorMedia.less');

var EditorAudioCover = React.createClass({
  mixins: [PureRenderMixin, createFlexibleImageQueueMixin(1)],

  propTypes: {
    duration: PropTypes.number.isRequired,
    tracks: PropTypes.arrayOf(PropTypes.object),
    artwork: PropTypes.shape({
      url: PropTypes.string.isRequired
    }).isRequired
  },

  getImageOptions() {
    return {
      image: this.props.artwork,
      mode: 'scale_crop',
      sizes: {
        thumb: true,
        normal: true,
        retina: window.devicePixelRatio > 1.5
      }
    };
  },

  componentDidUpdate(prevProps) {
    if (prevProps.artwork !== this.props.artwork) {
      this.updateImageQueue();
    }
  },

  render() {
    var { duration, tracks } = this.props;

    return (
      <div className='EditorMedia-cover'
           style={{
             backgroundImage: this.getBackgroundImageUrl()
           }}>

        {this.renderLoaderImg()}

        <div className='EditorMedia-badge'>
          <Icon className='EditorMedia-icon'
                name='audio'
                size='large'
                mode='stroke' />
          <div className='EditorMedia-duration'>
            {formatTime(duration)}
            {tracks &&
              <div className='EditorMedia-trackCount'>
                {tracks.length + ' ' + pluralize(tracks.length, 'track', 'tracks')}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
});

module.exports = EditorAudioCover;



/** WEBPACK FOOTER **
 ** ./editor/EditorAudioCover.jsx
 **/